import React from "react";

import * as styles from "./styles.module.scss";

type ResourceHubHeaderProps = {
  children: React.ReactNode;
  forwardedContainerRef: React.Ref<HTMLDivElement>;
};

const Header: React.FC<ResourceHubHeaderProps> = ({ children, forwardedContainerRef }) => {
  return (
    <div className={styles.ResourceHubHeader}>
      <div className="container" ref={forwardedContainerRef}>
        {children}
      </div>
    </div>
  );
};

export default Header;
